module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "jstree-node",
    class: {
      'jstree-last': _vm.last, 'jstree-open': _vm.folder.expanded, 'jstree-closed': !_vm.folder.expanded
    }
  }, [_c('i', {
    staticClass: "jstree-icon jstree-ocl",
    on: {
      "click": function($event) {
        _vm.expandNode()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "jstree-anchor",
    class: {
      'jstree-clicked': _vm.folder.id === _vm.activeFolder
    },
    on: {
      "click": function($event) {
        _vm.getResources(1, _vm.folder)
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.folder.name) + " \n\t\t"), (!_vm.activeLocationId && !_vm.selectOnly) ? _c('i', {
    staticClass: "fa",
    class: {
      'fa-eye': _vm.folder.is_shared, 'fa-eye-slash': !_vm.folder.is_shared
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.selectOnly) ? _c('i', {
    staticClass: "fa fa-pencil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.manageFolder()
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.folder.expanded) ? _c('ul', {
    staticClass: "jstree-children"
  }, [(!_vm.selectOnly) ? _c('li', {
    staticClass: "jstree-node jstree-leaf",
    class: {
      'jstree-last': !_vm.folder.children || !_vm.folder.children.length
    }
  }, [_c('i', {
    staticClass: "jstree-icon jstree-ocl"
  }), _vm._v(" "), _c('a', {
    staticClass: "jstree-anchor",
    on: {
      "click": function($event) {
        _vm.createFolder()
      }
    }
  }, [_c('button', {
    staticClass: "btn blue btn-xs"
  }, [_vm._v("Create Folder")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.folder.children), function(subfolder, subindex) {
    return [_c('resource-folder', {
      attrs: {
        "folder": subfolder,
        "activeFolder": _vm.activeFolder,
        "last": subindex === _vm.folder.children.length - 1,
        "selectOnly": _vm.selectOnly
      },
      on: {
        "expandNode": _vm.expandNode,
        "createFolder": _vm.createFolder,
        "manageFolder": _vm.manageFolder,
        "getResources": _vm.getResources
      }
    })]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7079a5a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Resources/ResourceFolder.vue
// module id = 441
// module chunks = 1